import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import GrayscalePDFImageListScreen from "./GrayscalePDFImageListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function GrayscalePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Convert PDF to Grayscale" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/grayscale_pdf", title: "Grayscale PDF file" },
    data2: { link: "/grayscale_pdf", title: "PDF Converter to Grayscale" },
    data3: { link: "/grayscale_pdf", title: "Convert PDF to Black & White" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to grayscale online. Reduce file size, save ink, and create black and white PDFs quickly with our fast and easy grayscale PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="grayscale PDF, convert PDF to grayscale, PDF to black and white, PDF color to grayscale, PDF editor online, black-and-white PDF, PDF optimization tool, reduce PDF size, PDF file converter, online PDF tool, PDF management tool, grayscale PDF converter, PDF color converter, PDF editing tool, compress PDF"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <GrayscalePDFImageListScreen
          title={title}
        ></GrayscalePDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Grayscale PDF Converter website provides a fast, secure, and efficient solution to convert color PDF files into grayscale both offline and online. Built for users who prioritize privacy and performance, this powerful tool allows you to convert PDFs to grayscale directly on your device without requiring an active internet connection. By processing files locally, the converter ensures complete data security while delivering high-quality grayscale output with clear text and optimized images. Whether you need to reduce ink usage for printing, create lightweight documents, or standardize PDFs for official submissions, this grayscale PDF converter delivers reliable results every time. In addition to offline functionality, the platform also supports grayscale PDF converter online features for users who prefer browser-based access. Using advanced conversion technology, the tool intelligently converts PDFs to grayscale while preserving layout, formatting, and readability. Ideal for students, professionals, and businesses, this grayscale PDF converter helps reduce file size, improve printing efficiency, and maintain document consistency. Compatible with desktop and mobile devices, the website offers a smooth, user-friendly experience without complex settings or software installation. If you are looking for the best grayscale PDF converter offline, grayscale PDF converter online, convert PDF to black and white, or a secure PDF color-to-grayscale tool, this platform is designed to meet all your document conversion needs with speed, accuracy, and privacy." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Grayscale PDF"
            why_use={[
              {
                title: "Reduce Printing Costs and Ink Usage",
                description:
                  "Color printing consumes more ink and increases costs. A grayscale PDF converter helps convert color PDFs to black and white, saving ink and making printing more economical.",
              },
              {
                title: "Optimize PDFs for Official Submissions",
                description:
                  "Many government forms, academic institutions, and corporate portals require documents in grayscale or black and white. Using a convert PDF to grayscale tool ensures compliance with submission guidelines.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Color images increase PDF file size. When you use a grayscale PDF converter online, it helps reduce PDF size while maintaining text clarity and document quality.",
              },

              {
                title: "Improve Document Readability",
                description:
                  "Grayscale PDFs remove unnecessary colors and distractions, making text and graphics easier to read. A PDF to grayscale converter improves visual consistency across pages.",
              },
              {
                title: "Enhance Printing Speed and Quality",
                description:
                  "Black-and-white documents print faster and more consistently than color files. A grayscale PDF converter ensures clean and sharp print results on all printers.",
              },
              {
                title: "Ensure Better Compatibility Across Devices",
                description:
                  "Some devices and e-readers display grayscale documents more clearly. Using a grayscale PDF converter online improves document compatibility on mobile, tablet, and desktop devices.",
              },
              {
                title: "Protect File Privacy with Offline Conversion",
                description:
                  "Our offline grayscale PDF converter processes files directly on your device, ensuring data privacy and security without uploading documents to the internet.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students submitting assignments and professionals preparing reports often need grayscale documents. A reliable PDF grayscale converter provides a quick and efficient solution.",
              },
              {
                title: "Standardize Document Appearance",
                description:
                  "Grayscale conversion ensures a uniform look for multi-page documents with mixed colors. A convert PDF to black and white tool maintains consistency and professionalism.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I convert a PDF to grayscale for free?",
                description:
                  "Visit ShivaPDF.com and open the Grayscale PDF tool. Select your PDF document and start the conversion to turn its colored content into shades of gray. Download the processed PDF to your device when it is ready.",
              },
              {
                title: "Can I convert a PDF to grayscale offline?",
                description:
                  "You can convert a PDF to grayscale offline if the tool and all required processing resources are available locally on your device. If the tool needs to load scripts or other resources from the internet, you may need to open it online first.",
              },
              {
                title: "Can I convert a PDF to grayscale without uploading it?",
                description:
                  "If ShivaPDF processes PDF files entirely in your browser, you can convert a document to grayscale without uploading its contents to a remote server. This can help protect the privacy of personal and confidential documents.",
              },
              {
                title: "Is it safe to convert PDF files to grayscale locally?",
                description:
                  "Local processing can help protect document privacy because the file does not need to be sent to a remote server. If you are working with sensitive documents, verify that the tool performs the conversion locally before using it.",
              },
              {
                title: "What does grayscale mean in a PDF?",
                description:
                  "Grayscale represents image and document content using shades of gray instead of color. Converting a PDF to grayscale can make colored text, photographs, graphics, and backgrounds appear in black, white, and intermediate gray tones.",
              },
              {
                title: "What is the difference between grayscale and black and white PDF?",
                description:
                  "A grayscale PDF can contain many shades between black and white, preserving more tonal detail in photographs and images. A strictly black-and-white document uses only black and white, which can be useful for simple text or high-contrast printing.",
              },
              {
                title: "Why should I convert a PDF to grayscale?",
                description:
                  "Converting a PDF to grayscale is useful when printing in black and white, preparing monochrome documents, or making colored content easier to reproduce without color ink. It can also provide a consistent appearance for documents intended for monochrome printing.",
              },
              {
                title: "Does converting a PDF to grayscale reduce file size?",
                description:
                  "Converting a PDF to grayscale may reduce its file size, but this is not guaranteed. The result depends on the document's images, fonts, compression methods, and how the grayscale conversion is performed.",
              },
              {
                title: "Will converting a PDF to grayscale affect text quality?",
                description:
                  "Grayscale conversion generally changes colors rather than the underlying text content. Text should remain readable when the original PDF is clear, although the appearance of colored text may change depending on how its colors translate into gray shades.",
              },
              {
                title: "Can I convert a colored PDF to black and white?",
                description:
                  "Yes, a grayscale conversion tool can turn colored PDF content into shades of gray. If you need strictly black-and-white output with no intermediate gray shades, check whether a separate monochrome or threshold conversion option is available.",
              },
              {
                title: "Can I convert a scanned PDF to grayscale?",
                description:
                  "Yes, a scanned PDF can be converted to grayscale if it is supported by the tool. The conversion changes the appearance of the scanned pages but does not automatically perform OCR or make image-based text searchable.",
              },
              {
                title: "Can I convert a PDF to grayscale without changing its layout?",
                description:
                  "Grayscale conversion is intended to change the document's color appearance while preserving its page layout. Text, images, and page positioning should remain in place, although the exact output depends on the conversion method.",
              },
              {
                title: "Can I convert a PDF to grayscale on my phone?",
                description:
                  "You can access ShivaPDF.com through a supported browser on an iPhone, Android phone, or tablet. Select your PDF and use the grayscale conversion feature, subject to your device's memory and the tool's file size limits.",
              },
              {
                title: "Do I need to install software to convert a PDF to grayscale?",
                description:
                  "No separate desktop application is needed when using a browser-based PDF grayscale converter. Open ShivaPDF.com in a supported browser, select your document, and follow the available conversion steps.",
              },
              {
                title: "Can I convert a password-protected PDF to grayscale?",
                description:
                  "Password-protected PDFs may require the correct password before they can be processed. Support depends on the PDF's security settings and the capabilities of the grayscale conversion tool.",
              },
              {
                title: "Will grayscale conversion remove images from my PDF?",
                description:
                  "Grayscale conversion is intended to change the colors of supported content rather than remove images. Photographs, diagrams, and graphics should remain visible, but their colors will appear as shades of gray.",
              },
              {
                title: "Can I convert multiple PDF files to grayscale at once?",
                description:
                  "Batch conversion is available only if the tool supports selecting and processing multiple PDF files in one operation. Check the ShivaPDF Grayscale PDF page for the currently available file selection options.",
              },
              {
                title: "Can I convert only selected pages of a PDF to grayscale?",
                description:
                  "Converting only selected pages is possible if the tool provides page selection or range options. If it processes the entire document, you may need a separate workflow to grayscale individual pages.",
              },
              {
                title: "Why do colors look different after converting a PDF to grayscale?",
                description:
                  "Different colors are translated into gray shades according to their brightness and the conversion method. Colors that look distinct in the original document may appear similar in grayscale, so review charts and color-coded information after conversion.",
              },
              {
                title: "How do I download a grayscale PDF?",
                description:
                  "After the conversion finishes, select the download option to save the grayscale PDF to your device. Open the downloaded file to check its readability, page layout, and image appearance before printing or sharing it.",
              },
              {
                title: "Why should I use ShivaPDF to convert PDFs to grayscale?",
                description:
                  "ShivaPDF offers browser-based PDF tools that help you manage documents without installing separate desktop software. Use the Grayscale PDF tool to prepare supported documents for monochrome printing, sharing, and viewing.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default GrayscalePDFMain;
